import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Home, Package } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get('order');

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-800 mb-2">Ödeme Başarılı!</h1>
          <p className="text-slate-500 mb-6">Siparişiniz başarıyla oluşturuldu.</p>
          
          {orderNumber && (
            <div className="bg-slate-100 rounded-lg p-4 mb-6">
              <p className="text-sm text-slate-500">Sipariş Numarası</p>
              <p className="font-mono font-bold text-orange-600 text-lg">{orderNumber}</p>
            </div>
          )}
          
          <p className="text-slate-400 text-sm mb-6">
            Siparişiniz en kısa sürede hazırlanacak ve kargoya verilecektir.
          </p>
          
          <div className="flex gap-3">
            <Button asChild variant="outline" className="flex-1">
              <Link to="/">
                <Home className="h-4 w-4 mr-2" />
                Ana Sayfa
              </Link>
            </Button>
            <Button asChild className="flex-1 bg-orange-500 hover:bg-orange-600">
              <Link to="/siparislerim">
                <Package className="h-4 w-4 mr-2" />
                Siparişlerim
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccessPage;
